import { Outlet, useNavigate, useLocation } from 'react-router-dom';
//import { useDispatch, useSelector } from 'react-redux';
import { useState } from 'react';
// material-ui
//import { useTheme } from '@mui/material/styles';
import { Box, useMediaQuery } from '@mui/material';

// project import
// import Drawer from './Drawer';
import Header from './Header';

// types
//import { openDrawer } from 'store/reducers/menu';
import { backgroundColor } from 'utils/constants';
import Swal from 'sweetalert2';
import ReportsSidebar from 'pages/Reports/ReportsSidebar';

// ==============================|| MAIN LAYOUT ||============================== //

const MainLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();


  const currentPath = location.pathname;
  const distibutor = JSON.parse(localStorage.getItem('distributor'));
  const retailerName = JSON.parse(localStorage.getItem('retailerName'));
  const fromritrival = JSON.parse(localStorage.getItem('fromritrival'));
  const fromedit = localStorage.getItem('fromedit');
  const fromreplicate = localStorage.getItem('fromreplicate');
  const [open, setOpen] = useState(true);
  const SIDEBAR_WIDTH = 250;
  const COLLAPSED_WIDTH = 72;
  const isMobileSidebar = useMediaQuery('(max-width:900px)');
  const hideOnPendingOrder = currentPath.includes('pending-order-reports') 
  || currentPath.includes('outstanding-reports')|| currentPath.includes('collection-recieved')
  || currentPath.includes('collection-target-achv-report')
  || currentPath.includes('current-month-sales-report');
  const effectiveSidebarWidth = hideOnPendingOrder ? 0 : isMobileSidebar ? 0 : open ? SIDEBAR_WIDTH : COLLAPSED_WIDTH;

  const hidePadding = currentPath.includes('report-dashboard') 
  || currentPath.includes('ledgerDivDetails');

  const hidebackIcon = currentPath.includes('report-dashboard') 
  || currentPath.includes('dashboard');
  const isFromApp =  localStorage.getItem('isFromApp') === 'true';
  //const theme = useTheme();
  // const matchDownLG = useMediaQuery(theme.breakpoints.down('lg'));
  // const dispatch = useDispatch();

  // const { drawerOpen } = useSelector((state) => state.menu);

  // drawer toggler
  //const [open, setOpen] = useState(drawerOpen);
  const handleDrawerToggle = () => {
    if (currentPath !== '/report-dashboard') {
      const containsProductBookingg = currentPath.includes('productBookingg');
      const containsProductBookingf = currentPath.includes('productBookingf');
      if (containsProductBookingg || containsProductBookingf) {
        showExitAlert();
      } else {
        const containssalesorder = currentPath.includes('salesorder');
        if (containssalesorder) {
          localStorage.setItem('SelectedCustomer', null);
          navigate('dashboard', { replace: true });
        } else if (currentPath === '/barcodedashboard') {
          navigate('salesorder', { replace: true });
        } else if (currentPath === '/beats') {
          navigate('dashboard', { replace: true });
        } else if (currentPath === '/good-returns-list') {
          navigate('dashboard', { replace: true });
        }
        else if (hideOnPendingOrder) {
          navigate('/report-dashboard', { replace: true });
        } else {
          navigate(-1, { replace: true });
        }
      }
    }

    // setOpen(!open);
    // dispatch(openDrawer({ drawerOpen: !open }));
  };
  const showExitAlert = async () => {
    const swalResult = await Swal.fire({
      title: 'Siyaram',
      text: 'Do you want to continue without saving current grid value ?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      allowOutsideClick: false,
      customClass: {
        confirmButton: 'swal-confirm-button',
        cancelButton: 'swal-cancel-button',
        actions: 'swal-buttons-container'
      },
      buttonsStyling: false
    });

    // Check the result to determine which button was clicked
    if (swalResult.isConfirmed) {
      // console.log('User clicked "Okay"');
      localStorage.setItem('orderupdatedList', null);
      localStorage.setItem('ordernumber', '');
      localStorage.setItem('materialListupdate', null);
      //localStorage.setItem("materialList",null);
      localStorage.setItem('sizexOriginalQty', null);
      // console.log("fromritrival===>"+fromritrival);

      if ((distibutor == 'undefined' || distibutor == null) && (retailerName == 'undefined' || retailerName == null) && fromedit !== '1') {
        navigate(-1, { replace: true });
      } else if (fromritrival === 1) {
        navigate(-2, { replace: true });
      } else if (fromreplicate === '1') {
        navigate(-1, { replace: true });
      } else {
        navigate(-1, { replace: true });
      }
    } else if (swalResult.isDismissed) {
      // console.log('User clicked "Cancel" or closed the dialogue');
      // Perform actions for "Cancel" button or closing the dialogue
    }
  };

  // set media wise responsive drawer
  // useEffect(() => {
  //   setOpen(!matchDownLG);
  //   dispatch(openDrawer({ drawerOpen: !matchDownLG }));

  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [matchDownLG]);

  // useEffect(() => {
  //   if (open !== drawerOpen) setOpen(drawerOpen);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [drawerOpen]);
/* ===================== 🔥 EARLY RETURN FOR APP ===================== */
  // 👉 App se aaya to kuch bhi layout load nahi hoga
  if (isFromApp) {
    return (
      <Box
        sx={{
          width: '100vw',
          height: '100vh',
          p: 0,
          m: 0,
          backgroundColor: backgroundColor
        }}
      >
        <Outlet />
      </Box>
    );
  }
  return (
    <Box sx={{ display: 'flex', width: '100%', backgroundColor: backgroundColor }}>
      {!hideOnPendingOrder && (
  <ReportsSidebar
    open={open}
    setOpen={setOpen}
    handleDrawerToggle={handleDrawerToggle}
  />
)}
      <Header
        open={open}
        setOpen={setOpen}
        sidebarWidth={effectiveSidebarWidth}
        hideOnPendingOrder={hideOnPendingOrder}
        hidebackIcon={hidebackIcon}
        handleDrawerToggle={handleDrawerToggle}
      />
      {/* <Drawer open={open} handleDrawerToggle={handleDrawerToggle} /> */}
      <Box
        component="main"
        sx={{
          minHeight: '100vh',
          flexGrow: 1,
          pt: { xs: 'calc(var(--main-layout-top-offset, 100px) + 10px)', md: '20px' },
          mt: 0,
          minWidth: 0,
          boxSizing: 'border-box',
          px: hidePadding ? 0 : { xs: 1, sm: 3 },
          pb: hidePadding ? 0 : { xs: 1, sm: 3 },
          ml: { md: `${effectiveSidebarWidth}px` }
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
};

export default MainLayout;
